module.exports = __webpack_public_path__ + "media/images/missing-category-active-16716d98ba4ff4e41af8ac0692e4f8a5.png";